import Vue from 'vue'
import { IsShow } from './IsShow';
import { IsInclude } from './IsInclude';
import { IsExist } from './IsExist';
import { Count } from './Count';
import { MatrixSum } from './MatrixSum';
import { MatrixDValue } from './MatrixDValue';
import { IsDefaultEligible } from './IsDefaultEligible';
import { getLastCaption, getCaption } from './Caption';
import { SetAnswer } from './SetAnswer';
import { IsAnswered } from './IsAnswered';
import { JumpTo } from './JumpTo';
import { ClearAnswer } from '../ClearAnswer';
import { InterceptMiddle } from '../../regular';
import { Order } from './Order';
import { OrderExist } from './OrderExist';
import { Length } from './Length';
import { HideOption } from './HideOption';




/**
 * 矩阵行显示逻辑
 * @param ques 当前试题
 * @param list 试题列表
 * @return value
 */
export const setMatrixRows = (list) => {
    // console.log('list :>> ', list);
    list = list.map(ques => {
        if (!ques.advancedScript) return ques
        // 获取条件
        let advancedScriptList = ques.advancedScript.split(/[\r\n]+/)
        // console.log('advancedScriptList :>> ', advancedScriptList);
        advancedScriptList.forEach(item => {
            if(!item) return
            // console.log('item :>> ', item);
            if (item.indexOf('MatrixSum') != -1) {
                MatrixSum(item, ques, list)
                return
            } else if (item.indexOf('MatrixD-value') != -1) {
                MatrixDValue(item, ques, list)
                return
            }
            let conditionStr = getLastCaption(item, 0, '\?') // 完整的条件
            let expression = conditionStr
            // console.log('conditionStr :>> ', conditionStr);
            let reg = /(Exist\[|\!Exist\[|Include\[|Exclude\[|IsShow\[|!IsShow\[|IsAnswered\[|Count\[|Order\[|OrderNot\[|OrderExist\[|OrderInexistence\[|Length\[)(.+?)(\])/ig
            let conditionArr = conditionStr.match(reg) // 所有条件arr
            // console.log('conditionArr :>> ', conditionArr);
            if (conditionArr) {
                conditionArr.forEach(info => {
                    let start = expression.indexOf(info);
                    let end = expression.indexOf("]", info);
                    let eligible = isEligible(item, list, info)
                    // console.log('eligible :>> ', eligible);
                    expression = expression.substr(0, start) + eligible + expression.substring(end + 1, expression.length);
                    // console.log('expression', expression)
                })
            }
            // console.warn('6 :>> ', 6);
            let behavior1 = InterceptMiddle(item, ['?'], ['!'])// 条件成立的行为
            // console.log('behavior1 :>> ', behavior1);
            let behavior2 = getLastCaption(item, 1, '\!')// 条件不成立的行为
            console.log('条件是否成立', item, expression)
            if (eval(expression)) {
                
                let { code, rowsArr } = getQuesCode(behavior1)
                list.forEach(info => {
                    code.forEach((codeInfo) => {
                        if (info.quesCode == codeInfo) {
                            info = toBehavior(codeInfo, rowsArr, list, behavior1, conditionArr)
                            // console.log('成立')
                            // console.log('info', info)
                        }
                    })
                })
            } else {
                let { code, rowsArr } = getQuesCode(behavior2)
                list.forEach(info => {
                    code.forEach((codeInfo) => {
                        if (info.quesCode == codeInfo) {
                            info = toBehavior(codeInfo, rowsArr, list, behavior2, conditionArr)
                            // console.log('bu成立')
                            // console.log('info', info)
                        }
                    })
                })
            }
            return item
        });
        return ques
    })
    return list
}
const getQuesCode = (behavior, list) => {
    let newCondition = InterceptMiddle(behavior, ['['], [']']) // 不带方括号的条件
    let code = InterceptMiddle(newCondition, [], ['==',':'])// 试题编码
    code = code ? code : newCondition
    code = code.split(',')
    let rowsArr = newCondition.split(':')[1] ? newCondition.split(':')[1].split(','): [] // 行号arr
    return {
        code,
        rowsArr
    }
}

/**
 * 按要求返回需要显示的行/题
 * @param behavior 
 * @param list 试题列表
 * @param code 试题编码
 * @param rowsArr 行号arr
 * @param conditionArr 完整的条件list
 * @return boolean
 */
const toBehavior = (code, rowsArr, list, behavior, conditionArr) => {
    // console.log('code :>> ', code);
    let resultQues = {}
    list = list.map((info, index) => {
        console.log('code :>> ', code);
        if (code == info.quesCode) {
            // console.log('rowsArr :>> ', rowsArr);
            console.log('object :>> ', getLastCaption(behavior, 0, '\['));
            switch (getLastCaption(behavior, 0, '\[')) {
                case 'MatrixRowHide':
                    // console.warn('不成立并渲染')
                    let questionsSonListCopy = JSON.parse(JSON.stringify(info.questionsSonList)) 
                    info.questionsSonList = questionsSonListCopy.filter((son) => {
                        return rowsArr.indexOf(son.orderNum.toString()) == -1
                    })
                    break;
                    
                case 'MatrixRowShow':
                    // console.warn('成立并渲染')
                    let newArr = [...info.questionsSonList, ...info.questionsSonListCopy.filter((son) => {
                        return rowsArr.indexOf(son.orderNum.toString()) != -1
                    })]
                    info.questionsSonList = info.questionsSonListCopy.filter(info =>{
                        let state = false
                        newArr.forEach(val =>{
                            if (info.orderNum == val.orderNum) {
                                state = true
                            }
                        })
                        if (state) return info
                    })
                    info = setIsSelected(info)
                    // console.warn('info.questionsSonList :>> ', info.questionsSonList);
                    break;
                case 'QuesShow':
                    info.bindIsShow = true
                    break;
                case 'QuesHide':
                    info.bindIsShow = false
                    info = ClearAnswer(info)
                    break;
                case 'SetAnswer':
                    SetAnswer(info, behavior)
                    break;
                case 'JumpTo':
                    JumpTo(code, conditionArr, list, 1)
                    break;
                case 'RecoverJumpTo':
                    JumpTo(code, conditionArr, list, 0)
                    break;
                case 'IsMust':
                    info.mustanswer = true
                    break;
                case 'IsNotMust':
                    info.mustanswer = false
                    break;
                case 'HideOption':
                    HideOption(rowsArr, info)
                    break;
                case 'ShowOption':
                    rowsArr.forEach((opIndex) => {
                        opIndex = Number(opIndex)
                        console.log('opIndex :>> ', opIndex);
                        Vue.prototype.$set(info.optionList[opIndex - 1],'show',true)
                        
                        // info.optionList[opIndex - 1].show = true
                        console.log('info :>> ', info);
                    })
                    break;
            }
            resultQues = info
        }
        return info
    })
    return resultQues;
}

/**
 * 矩阵题 条件成立时根据userAnswerArr，给questionsSonList中isSelected设置回显值
 * @param ques 
 * @return arr
 */
const setIsSelected = (ques) => {
    ques.questionsSonList = ques.questionsSonList.map((val) => {
        ques.userAnswerArr.forEach((info) => {
            switch (ques.questionsTypeId) {
                case '19': 
                    if (info.SonId == val.SonId) {
                        val.isSelected = info.value.split(':')[0];
                        val.inputValue = info.value.split(':')[1] || '';
                        val.optionList.forEach(oid => {
                            if (info.value.indexOf(oid.oid) !== -1) {
                                oid.inputValue = info.value.split(':')[1] || '';
                            }
                        });
                    }
                    break
                case '20': 
                    if (info.SonId == val.SonId) {
                        val.optionList.forEach(oid => {
                            let arr = [];
                            arr = info.value.split(',');
                            arr.forEach(el => {
                                if (el.indexOf(oid.oid) !== -1) {
                                    oid.isSelected = true;
                                    oid.inputValue = el.split(':')[1] || '';
                                }
                            });
                        });
                    }
                    break
                case '21': 
                    if (info.SonId == val.SonId) {
                        val.optionList.forEach(oid => {
                            info.optionValue.forEach(el => {
                                if (oid.oid == el.oid) {
                                    oid.ratingScore = el.value;
                                }
                            });
                        });
                    }
                    break
                case '22': 
                    if (info.SonId == val.SonId) {
                        val.optionList.forEach(oid => {
                            info.optionValue.forEach(el => {
                                if (oid.oid == el.oid) {
                                    oid.userAnswer = el.value;
                                }
                            });
                        });
                    }
                    break
                case '39': 
                    if (info.SonId == val.SonId) {
                        val.optionList.forEach(oid => {
                            info.optionValue.forEach(el => {
                                if (oid.oid == el.oid) {
                                    oid.userAnswer = el.value;
                                }
                            });
                        });
                    }
                    break
                    
            }
        })
        return val
    })
    // console.log('ques.questionsSonList :>> ', ques.questionsSonList);
    return ques
}




/**
 * 解析题目编码前的函数并判断条件是否成立
 * @param text 
 * @param state 0前 1后
 * @param str 指定字符
 * @param condition 完整的一个条件
 * @return boolean
 */
const isEligible = (text, list, condition) => {
    // console.log('condition', condition)
    let result = false
    // console.warn('7 :>> ', 7);
    let newCondition = InterceptMiddle(condition, ['['], [']']) // 不带方括号的条件
    
    // console.log('newCondition :>> ', newCondition);
    let existFunction = getCaption(text, 0, '\[')
    // console.log('existFunction :>> ', existFunction);
    switch(existFunction) {
        case 'Exist':
            // 存在 Exist[Q1:2:1,2,3]
            // console.log('IsExist(list, newCondition) :>> ', IsExist(list, newCondition));
            result = IsExist(list, newCondition)
            break
        case '!Exist':
            // 不存在 !Exist[Q1:2:1,2,3]
            result = !IsExist(list, newCondition)
            break
        case 'Include':
            // 包含 Include[Q1:1,2]
            result = IsInclude(list, newCondition)
            break
        case 'Exclude':
            // 不包含 Exclude[Q1:1,2]
            result = !IsInclude(list, newCondition)
            break
        case 'IsShow':
            // 试题显示 IsShow[Q1]
            result = IsShow(list, newCondition)
            break
        case '!IsShow':
            // 试题不显示 !IsShow[Q1]
            result = !IsShow(list, newCondition)
            break
        case 'IsAnswered':
            // 试题不显示 !IsAnswered[Q1,Q2]
            result = IsAnswered(list, condition)
            break
        case 'Count':
            // 选项合计数
            result = Count(list, condition)
            break
        case 'Order':
            // 排序
            result = Order(list, condition)
            break
        case 'OrderNot':
            // 排序
            result = !Order(list, condition)
            break
        case 'OrderExist':
            // 排序
            result = OrderExist(list, condition)
            break
        case 'OrderInexistence':
            // 排序
            result = !OrderExist(list, condition)
            break
        case 'Length':
            // 排序
            result = !Length(list, condition)
            break
        default:
            // 获取单选条件 例如：[Q1==1]
            // console.log('默认 :>> ', '默认');
            result = IsDefaultEligible(list, newCondition, condition, text)
            // console.log('result :>> ', result);
            break
    }
    return result;
}

